import { render, staticRenderFns } from "./WGN.vue?vue&type=template&id=bfa5d3d6&scoped=true&"
import script from "./WGN.vue?vue&type=script&lang=js&"
export * from "./WGN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa5d3d6",
  null
  
)

export default component.exports